import { PayloadAction } from '@reduxjs/toolkit';

export const illegalAction = <S>(
  reducerName: string,
  action: PayloadAction<unknown>,
  prevState: S
): never => {
  throw Error(
    `Reducer ${reducerName}: Cannot apply action ${
      action.type
    } on state ${JSON.stringify(prevState)}.`
  );
};
